import * as Sentry from "sentry-expo";
import { App } from "./components/App";

Sentry.init({
  dsn:
    "https://2c44fd2dc9a24db1acd78d4d3bd232ce@o354606.ingest.sentry.io/5618507",
});

export default App;